// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UpdatesAvailableProductOfferingFragment = { __typename?: 'ProductOfferingIncomingUpdate', id: string, createdAt: Types.Scalars['DateTime']['input'], forDesignPackageUpdate: boolean, forPlanPackageUpdate: boolean, source: { __typename?: 'Drop', id: string, name: string } | { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } | { __typename?: 'PlanPackage', id: string, name: string } | { __typename?: 'DesignPackage', id: string, name: string } | { __typename?: 'ProductOffering', id: string, name: string }, tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, identity: { __typename?: 'TakeoffLineItem', id: string, isPlaceholderMaterial: boolean } }>, rplVersions: Array<{ __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string }> } };

export type UpdatesAvailableSourceRpavFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } | { __typename?: 'PlanPackage', id: string, name: string } | { __typename?: 'DesignPackage', id: string, name: string } | { __typename?: 'ProductOffering', id: string, name: string }, tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, identity: { __typename?: 'TakeoffLineItem', id: string, isPlaceholderMaterial: boolean } }>, rplVersions: Array<{ __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string }> };

export type PofAvailableUpdatesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PofAvailableUpdatesQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, availableUpdates: Array<{ __typename?: 'ProductOfferingIncomingUpdate', id: string, createdAt: Types.Scalars['DateTime']['input'], forDesignPackageUpdate: boolean, forPlanPackageUpdate: boolean, source: { __typename?: 'Drop', id: string, name: string } | { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } | { __typename?: 'PlanPackage', id: string, name: string } | { __typename?: 'DesignPackage', id: string, name: string } | { __typename?: 'ProductOffering', id: string, name: string }, tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, identity: { __typename?: 'TakeoffLineItem', id: string, isPlaceholderMaterial: boolean } }>, rplVersions: Array<{ __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string }> } }> } };

export type AcceptProductOfferingUpdatesMutationVariables = Types.Exact<{
  input: Types.AcceptProductOfferingUpdatesInput;
}>;


export type AcceptProductOfferingUpdatesMutation = { __typename?: 'Mutation', acceptProductOfferingUpdates: { __typename?: 'ProductOffering', id: string } };

export const UpdatesAvailableSourceRpavFragmentDoc = gql`
    fragment UpdatesAvailableSourceRpav on ReadyPlanAggregateVersion {
  id
  name
  version
  versionNotes
  readyPlan {
    id
    name
  }
  tliVersions {
    id
    changeType
    identity {
      id
      isPlaceholderMaterial
    }
  }
  rplVersions {
    id
    changeType
  }
}
    `;
export const UpdatesAvailableProductOfferingFragmentDoc = gql`
    fragment UpdatesAvailableProductOffering on ProductOfferingIncomingUpdate {
  id
  createdAt
  forDesignPackageUpdate
  forPlanPackageUpdate
  source {
    ... on Drop {
      id
      name
    }
    ...UpdatesAvailableSourceRpav
  }
}
    ${UpdatesAvailableSourceRpavFragmentDoc}`;
export const PofAvailableUpdatesDocument = gql`
    query PofAvailableUpdates($id: ID!) {
  productOffering(id: $id) {
    id
    availableUpdates {
      ...UpdatesAvailableProductOffering
    }
  }
}
    ${UpdatesAvailableProductOfferingFragmentDoc}`;

/**
 * __usePofAvailableUpdatesQuery__
 *
 * To run a query within a React component, call `usePofAvailableUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePofAvailableUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePofAvailableUpdatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePofAvailableUpdatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PofAvailableUpdatesQuery, PofAvailableUpdatesQueryVariables> & ({ variables: PofAvailableUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PofAvailableUpdatesQuery, PofAvailableUpdatesQueryVariables>(PofAvailableUpdatesDocument, options);
      }
export function usePofAvailableUpdatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PofAvailableUpdatesQuery, PofAvailableUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PofAvailableUpdatesQuery, PofAvailableUpdatesQueryVariables>(PofAvailableUpdatesDocument, options);
        }
export function usePofAvailableUpdatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PofAvailableUpdatesQuery, PofAvailableUpdatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PofAvailableUpdatesQuery, PofAvailableUpdatesQueryVariables>(PofAvailableUpdatesDocument, options);
        }
export type PofAvailableUpdatesQueryHookResult = ReturnType<typeof usePofAvailableUpdatesQuery>;
export type PofAvailableUpdatesLazyQueryHookResult = ReturnType<typeof usePofAvailableUpdatesLazyQuery>;
export type PofAvailableUpdatesSuspenseQueryHookResult = ReturnType<typeof usePofAvailableUpdatesSuspenseQuery>;
export type PofAvailableUpdatesQueryResult = Apollo.QueryResult<PofAvailableUpdatesQuery, PofAvailableUpdatesQueryVariables>;
export const AcceptProductOfferingUpdatesDocument = gql`
    mutation AcceptProductOfferingUpdates($input: AcceptProductOfferingUpdatesInput!) {
  acceptProductOfferingUpdates(input: $input) {
    id
  }
}
    `;
export type AcceptProductOfferingUpdatesMutationFn = Apollo.MutationFunction<AcceptProductOfferingUpdatesMutation, AcceptProductOfferingUpdatesMutationVariables>;

/**
 * __useAcceptProductOfferingUpdatesMutation__
 *
 * To run a mutation, you first call `useAcceptProductOfferingUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptProductOfferingUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptProductOfferingUpdatesMutation, { data, loading, error }] = useAcceptProductOfferingUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptProductOfferingUpdatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptProductOfferingUpdatesMutation, AcceptProductOfferingUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptProductOfferingUpdatesMutation, AcceptProductOfferingUpdatesMutationVariables>(AcceptProductOfferingUpdatesDocument, options);
      }
export type AcceptProductOfferingUpdatesMutationHookResult = ReturnType<typeof useAcceptProductOfferingUpdatesMutation>;
export type AcceptProductOfferingUpdatesMutationResult = Apollo.MutationResult<AcceptProductOfferingUpdatesMutation>;
export type AcceptProductOfferingUpdatesMutationOptions = Apollo.BaseMutationOptions<AcceptProductOfferingUpdatesMutation, AcceptProductOfferingUpdatesMutationVariables>;